import { useEffect, useState } from "react";

// True only when InfoCityJobs is running as an installed/standalone PWA (or
// iOS "Add to Home Screen") — NOT for plain mobile Safari/Chrome, where the
// page still needs to work as a normal presentational/SEO landing page.
function detectStandalone() {
  const mqStandalone = window.matchMedia?.("(display-mode: standalone)").matches;
  const iosStandalone = window.navigator.standalone === true; // iOS Safari-specific flag
  return Boolean(mqStandalone || iosStandalone);
}

export function usePWAStandalone() {
  const [standalone, setStandalone] = useState(detectStandalone);

  useEffect(() => {
    const mq = window.matchMedia("(display-mode: standalone)");
    const handler = () => setStandalone(detectStandalone());
    mq.addEventListener?.("change", handler);
    return () => mq.removeEventListener?.("change", handler);
  }, []);

  return standalone;
}
